module.exports = __webpack_public_path__ + "static/media/calender.50c28a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/calender.png
// module id = 902
// module chunks = 0